import React, { useMemo, useState } from 'react';
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';

import {
  ILearningCenterNewPopularArticlesFields,
  ILearningCenterArticle
} from '@/types/contentful';

import { ArticleSnippet } from '../ArticleSnippet';

export function FeaturedPosts({
  newArticles,
  popularArticles,
  recommendedArticles
}: Partial<ILearningCenterNewPopularArticlesFields>) {
  const [currentTabIdx, setCurrentTabIdx] = useState<number>(0);

  const allArticles = useMemo(
    () =>
      omitBy(
        {
          'for you': recommendedArticles,
          new: newArticles,
          popular: popularArticles
        },
        isEmpty
      ),
    [newArticles, popularArticles, recommendedArticles]
  );

  const tabs = useMemo(() => Object.keys(allArticles), [allArticles]);

  return (
    <section
      className="z-[2] mt-4 inline-flex w-full flex-col items-center gap-4 rounded-2xl p-0"
      data-blockid="featuredPostsContainer"
      data-testid="featuredPostsContainer"
    >
      <div className="flex w-full items-start gap-4 rounded-2xl bg-white p-2">
        {tabs.map((tab, idx) => (
          <button
            key={tab}
            className={`w-full flex-1 cursor-pointer rounded-md px-4 py-2 text-center text-base font-medium leading-tight 
              ${
                currentTabIdx === idx ? 'bg-[#99EDC5]' : 'bg-[#F3F3F3]'
              } hover:bg-[#99EDC5]`}
            onClick={() => setCurrentTabIdx(idx)}
          >
            {capitalize(tab)}
          </button>
        ))}
      </div>
      <div className="flex w-full flex-col gap-4">
        {allArticles[tabs[currentTabIdx]]?.map(
          ({ sys, fields }: ILearningCenterArticle) => (
            <ArticleSnippet key={sys.id} fields={fields} />
          )
        )}
      </div>
    </section>
  );
}
